import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBack"><Path d="M5.5 4.5V19.5M18.5 5L7.78572 12L18.5 19V5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBack;
